import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import { DEFAULT_PAGE_SIZE } from '../../../../config/constants';
import ModuleList from '../../../layout/ModuleList';
import {
  CABIN_CREW_BUS_ASSIGNMENT_PATH,
  NEW_CABIN_CREW_BUS_ASSIGNMENT_PATH,
} from '../../../../config/paths';
import {
  getCabinCrewBusAssignments,
  clearCabinCrewBusAssignments,
  exportFile,
} from '../../../../actions/traffic/CabinCrewBusAssignment';
import { CABIN_CREW_BUS_ASSIGNMENT_COLUMNS } from '../../../../config/columns';
import { breadcrumbsPropTypes } from '../../../common/resource/proptypes/CommonPropTypes';

const CabinCrewBusAssignments = ({
  cabinCrewAssignments,
  loading,
  breadcrumbs,
  dispatchGetCabinCrewBusAssignments,
  dispatchClearCabinCrewBusAssignments,
  dispatchExportFile
}) => {

  useEffect(() => () => {
    dispatchClearCabinCrewBusAssignments();
  }, [dispatchClearCabinCrewBusAssignments]);

  const data = cabinCrewAssignments.get('content') || [];
  const pages = cabinCrewAssignments.get('totalPages') || null;
  const defaultPageSize = cabinCrewAssignments.get('size') || DEFAULT_PAGE_SIZE;

  const handleExport = () => {
    dispatchExportFile();
  }

  const extraButtons = (
    <Button onClick={handleExport} color="secondary" className="mr-2">
      <i className="fa fa-file-excel-o mr-2" />
      Exportar
    </Button>
  )

  return (
    <ModuleList
      title="Asignaciones de Servicio a Bordo"
      buttonPath={NEW_CABIN_CREW_BUS_ASSIGNMENT_PATH}
      extraButtons={extraButtons}
      breadcrumbs={breadcrumbs}
      tableStructure={{
        columns: CABIN_CREW_BUS_ASSIGNMENT_COLUMNS,
        data,
        pages,
        defaultPageSize,
        filterable: true,
        fetchData: dispatchGetCabinCrewBusAssignments,
        modelPath: CABIN_CREW_BUS_ASSIGNMENT_PATH,
        loading,
        navigateToModelOnRowClick: true,
      }}
    />
  );
};

const mapDispatchToProps = {
  dispatchGetCabinCrewBusAssignments: getCabinCrewBusAssignments,
  dispatchClearCabinCrewBusAssignments: clearCabinCrewBusAssignments,
  dispatchExportFile: exportFile
};

const mapStateToProps = ({ TrafficUnit }) => ({
  breadcrumbs: [
    ...TrafficUnit.CabinCrewUnitHome.get('breadcrumbs'),
    {
      text: 'Asignaciones de Servicio a Bordo',
      href: CABIN_CREW_BUS_ASSIGNMENT_PATH,
    },
  ],
  cabinCrewAssignments: TrafficUnit.CabinCrewBusAssignment.getIn(['all', 'content']),
  loading: TrafficUnit.CabinCrewBusAssignment.getIn(['all', 'loading']),
});

CabinCrewBusAssignments.propTypes = {
  breadcrumbs: breadcrumbsPropTypes.isRequired,
  cabinCrewAssignments: PropTypes.instanceOf(Immutable.Map),
  loading: PropTypes.bool,
  dispatchGetCabinCrewBusAssignments: PropTypes.func.isRequired,
  dispatchClearCabinCrewBusAssignments: PropTypes.func.isRequired,
  dispatchExportFile: PropTypes.func.isRequired,
};

CabinCrewBusAssignments.defaultProps = {
  cabinCrewAssignments: null,
  loading: false,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(CabinCrewBusAssignments);